import { LayoutWithSubNav } from '@components/Layout/Layout';
import { navId } from '@containers/Product/ProductSubNav';

export const ProductLayout = () => LayoutWithSubNav({ navId });
